export default {
  namespaced  : true,
  
  state       : {
    // isOpenModal           : false,
    isLoadingModal        : false,

    selectedInfomationId  : null,

    hasUnreadedInfomation : false
  },

  mutations   : {
    setIsLoadingModal(state, value){
      state.isLoadingModal = value;
    },

    // setIsOpenModal(state, value){
    //   state.isOpenModal = value;
    // },

    setSelectedInfomationId(state, value){
      state.selectedInfomationId = value;
    },

    setHasUnreadedInfomation(state, value){
      state.hasUnreadedInfomation = value;
    },

    resetStore(state){
      state.isLoadingModal        = false;
      state.selectedInfomationId  = null;
      state.hasUnreadedInfomation = false;
    }
  },

  actions     : {
    updateIsLoadingModal(context, payload){
      context.commit('setIsLoadingModal', payload.value);
    },

    // updateIsOpenModal(context, payload){
    //   context.commit('setIsOpenModal', payload.value);
    // },

    updateSelectedInfomationId(context, payload){
      context.commit('setSelectedInfomationId', payload.value);
    },

    updateHasUnreadedInfomation(context, payload){
      context.commit('setHasUnreadedInfomation', payload.value);
    },

    resetStore(context){
      context.commit('resetStore');
    }
  }
}